module.exports = __webpack_public_path__ + "/build/web/images/hero-stalenservice.7bdc16a1c6722588c83a6a6b8c7acbea.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-stalenservice.jpg
// module id = 145
// module chunks = 13